import { useEffect } from 'react';
import { audioCueService } from 'modules/audioCueService';
import { useToolPreferences } from 'hooks/usePreferences';
import type { WithApolloContext } from 'modules/Apollo/types';

export const useAudioCueServiceSync = ({ context }: WithApolloContext): void => {
  const [toolPreferences] = useToolPreferences({ context });
  const playAudioCues = toolPreferences?.dictaphone.playAudioCues?.startStopRecording;

  useEffect(() => {
    if (playAudioCues === undefined) return;
    audioCueService.setEnabled(playAudioCues);
  }, [playAudioCues]);
};
